import { Assets, Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import type { MenuIcon } from '../types';
import { SpecialOfferMenuIconLayout } from '../../../layouts/specialOffers/SpecialOfferMenuIconLayout';
import type { IAPProduct } from '../../app/iap/types';
import { playLayoutAnimation } from '../../libs/layouts/layoutAnimations/playLayoutAnimation';

export class OfferMenuButtonView extends Container implements MenuIcon {
  public readonly onClicked = new Signal<(product: IAPProduct) => void>();

  public readonly onVisibilityChanged = new Signal<(visible: boolean) => void>();

  private currentProduct: IAPProduct | null = null;

  private readonly layout = new SpecialOfferMenuIconLayout();

  constructor() {
    super();

    this.layout.root.on('pointertap', () => {
      if (!this.currentProduct) return;
      this.onClicked.emit(this.currentProduct);
    });
    this.layout.root.props({
      parent: this,
    });

    void playLayoutAnimation(this.layout, 'IdleAnimation', true);
    this.visible = false;
  }

  public setCurrentOffer(product: IAPProduct | null): void {
    if (product?.id === this.currentProduct?.id) return;

    this.currentProduct = product;

    this.visible = !!product;
    this.onVisibilityChanged.emit(this.visible);

    if (!product) return;

    void this.refreshIcon(product);
  }

  public async refreshIcon(product: IAPProduct): Promise<void> {
    if (this.destroyed) return;

    const { offerIcon } = this.layout;

    offerIcon.scale.set(0);

    const iconProps = product.data.menuIconAssets?.icon ?? { texture: 'Special_Offer_Icon' };

    if (iconProps.texture) {
      await Assets.load(iconProps.texture);
    }

    if (offerIcon.destroyed) return;

    if (this.currentProduct !== product) return;

    offerIcon.props(iconProps);
    offerIcon.tweenTo({ scaleXY: 1 }, 400, 'appear1', true);
  }

  public isVisible(): boolean {
    return this.visible;
  }

  public getProduct(): IAPProduct | null {
    return this.currentProduct;
  }
}
